import "bootstrap/dist/css/bootstrap.min.css";

import {BrowserRouter, Route, Routes } from "react-router-dom";
import { UserStorage } from "./context/UserContext";
import ProtectRouter from "./components/ProtectRouter";

import {Footer} from './components/Footer'
import { Login } from "./Pages/Login";
import { Home } from "./Pages/Home";
import { Users } from "./Pages/Users/ListUsers";
import { NotFound } from "./Pages/NotFound";
import { NewUser } from "./Pages/Users/NewUser";
import { EditUser } from "./Pages/Users/EditUser";
import { Campain } from "./Pages/Campain/ListCampain";
import { EditCampain } from "./Pages/Campain/EditCampain";
import { NewCampain } from "./Pages/Campain/NewCampain";
import { Client } from "./Pages/Clients/ListClient";
import { EditClient } from "./Pages/Clients/EditClient";
import { NewClient } from "./Pages/Clients/NewClient";
import { Applications } from "./Pages/Applications/ListAplications";
import { NewApplication } from "./Pages/Applications/NewAplication";
import { EditApplication } from "./Pages/Applications/EditAplication";
import { CampainMedia } from "./Pages/Campain/CampainMedia";
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <UserStorage>
        <main>
          <Routes>
            <Route exact path="/"  element={<Login />} />

            <ProtectRouter path="moderation" element={<Home />} />


            <ProtectRouter path="/users" element={<Users />} />
            <ProtectRouter path="/users/new-user" element={<NewUser/>} />
            <ProtectRouter path="/users/edit-user/:id" element={<EditUser/>} />

            {/* Campaim */}
            <ProtectRouter path="/campain" element={<Campain />} />
            <ProtectRouter path="/campain/:id" element={<CampainMedia />} />
            <ProtectRouter path="/campain/new-campain" element={<NewCampain/>} />
            <ProtectRouter path="/campain/edit-campain/:id" element={<EditCampain/>} />

            {/* Client */}
            <ProtectRouter path="/client" element={<Client />} />
            <ProtectRouter path="/client/new-client" element={<NewClient/>} />
            <ProtectRouter path="/client/edit-client/:id" element={<EditClient />} />

            {/* Applications */}
            <ProtectRouter path="/app" element={<Applications />} />
            <ProtectRouter path="/app/new-app" element={<NewApplication />} />
            <ProtectRouter path="/app/edit-app/:id" element={<EditApplication />} />



            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </main>
      </UserStorage>
    </BrowserRouter>
  );
}
